import "./modal.css";
import React, { useState } from "react";
import { ModalButtons } from "../../ModalButtons/modalButtons";
import { ModalInputMotivo } from "../../ModalMotivo/ModalInputMotivo";
interface ModalProps {
  titleModal?: string;
  titleDescription?: React.ReactNode;
  bodyModal?: React.ReactNode;
  buttonOne?: string;
  titleLabel?: string;
  buttonTwo?: string;
  inputMotivo?: boolean;
  inputNCM?: string;
  buttonThree?: string;
  onLogout?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  commentText?: string;
  setCommentText?: (text: string) => void;
  isButtonDisabled?: boolean;
  onDisableButton?: (disabled: boolean) => void;
  isSubmitting?: boolean;
}

export const Modal = ({
  titleModal,
  titleDescription,
  bodyModal,
  buttonOne,
  titleLabel,
  buttonTwo,
  inputMotivo,
  inputNCM,
  buttonThree,
  onClose,
  onConfirm,
  onLogout,
  className,
  commentText,
  setCommentText,
  isButtonDisabled,
  onDisableButton,
  isSubmitting,
}: ModalProps) => {
  const [value, setValue] = useState(commentText || "");
  const [commentError, setCommentError] = useState("");
  const MAX_LENGTH = 500;

  React.useEffect(() => {
    setValue(commentText || "");
  }, [commentText]);

  const handleInputChange = (newValue: string) => {
    if (newValue.length >= MAX_LENGTH) {
      setCommentError("Limite de 500 caracteres atingido");
      if (onDisableButton) {
        onDisableButton(false);
      }
    } else {
      setCommentError("");
      if (onDisableButton) {
        onDisableButton(newValue.length === 0);
      }
    }

    setValue(newValue);

    if (setCommentText && newValue.length <= MAX_LENGTH) {
      setCommentText(newValue);
    }
  };

  return (
    <div className={`modalCorporateSession ${className}`}>
      <div className="modal">
        <div>
          <div className="containerTitleModal">
            {titleModal && <h1 className="titleModal">{titleModal}</h1>}
          </div>
          <div className="containerDescription">
            {titleDescription && (
              <span
                className="bodyModal"
                style={{ paddingTop: "20px", paddingBottom: "20px" }}
              >
                {titleDescription}
              </span>
            )}

            {bodyModal && (
              <span className="bodyModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            <ModalInputMotivo
              inputMotivo={inputMotivo}
              titleLabel={titleLabel}
              value={value}
              setValue={handleInputChange}
              errorMessage={commentError}
            />

            <ModalButtons
              buttonOne={buttonOne}
              buttonTwo={buttonTwo}
              buttonThree={buttonThree}
              onConfirm={onConfirm}
              onClose={onClose}
              onLogout={onLogout}
              isButtonDisabled={isButtonDisabled}
              isSubmitting={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
